import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Utilities} from '../../utilities/utilities.model';
import {MatAutocompleteSelectedEvent} from '@angular/material';

@Component({
	selector: 'amd-autocomplete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.scss']
})
export class AutoCompleteComponent implements OnInit, OnChanges {
	@Input() floatLabel = 'auto';
	@Input() flagSaveEnabled = true;
	@Input() placeholder: string;
	@Input() needMatching = true;
	@Input() isRequired = false;
	@Input() maxLength = -1;
	@Input() errorMessage: string;
	@Input() errorRequiredMessage: string;
	@Input() model: any;
	@Input() locale: any;
	@Input() listFrom: AutoCompleteItemModel[];
	@Input() getValidators = false;

	@Output() autoCompleteChangedEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() focusIn: EventEmitter<void> = new EventEmitter<void>();
	@Output() focusOut: EventEmitter<void> = new EventEmitter<void>();

	subList: Observable<any[]>;
	tempModel: any;
	outOfRange = false;
	dirty = false;

	constructor() {
	}

	ngOnInit() {
	}


	ngOnChanges(changes: SimpleChanges): void {
		if (!Utilities.isVoid(changes.listFrom) && !Utilities.isVoid(changes.listFrom.currentValue)) {
			this.listFrom = changes.listFrom.currentValue;
		}
		if (!Utilities.isVoid(changes.locale) && !Utilities.isVoid(changes.locale.currentValue)) {
			this.locale = changes.locale.currentValue;
		} else {
			this.locale = 'it';
		}
		if (!Utilities.isVoid(changes.model) && !Utilities.isVoid(changes.model.currentValue)) {
			this.model = changes.model.currentValue;
			this.subList = this.asyncFilter(this.model);
			this.tempModel = this.getMLabel(this.model);
			this.onChange(null);
		}
		if (!Utilities.isVoid(changes)) {
			if (!Utilities.isVoid(changes.getValidators) && !Utilities.isVoid(changes.getValidators.currentValue)) {
				this.getValidatorsEventListener(changes.getValidators.currentValue);
			}
		}
	}

	resetModel(modelValue: string) {
		this.model = modelValue;
		this.subList = this.asyncFilter(this.model);
		this.tempModel = this.getMLabel(this.model);
		this.onChange(null);
	}

	getValidatorsEventListener(event: boolean) {
		this.dirty = event;
	}

	asyncFilter(val: any): Observable<any[]> {
		return new Observable<any[]>(observer => {
			setInterval(() => {
				observer.next(!Utilities.isVoid(this.listFrom) ? (!Utilities.isVoid(val) ? this._filter(val) : this.listFrom) : [])
			}, 100)
		});
	}

	private _filter(val: any) {
		const filterValue = val.toString().toLowerCase();
		return this.listFrom.filter(item => (!Utilities.isVoid(item.labels) && !Utilities.isVoid(item.labels[this.locale])) ?
			item.labels[this.locale].toLowerCase().includes(filterValue) : item.value.toString().toLowerCase().includes(filterValue));

	}

	onItemChange(event: MatAutocompleteSelectedEvent) {
		const value = event.option.value;
		setTimeout(() => this.tempModel = this.getMLabel(value), 0);
		this.eventEmitter(!Utilities.isVoid(value) ? value : '');
	}

	onChange(event: any) {
		if (this.needMatching) {
			this.eventEmitter(this.getMValue(this.tempModel));
		} else {
			this.eventEmitter(this.tempModel);
		}
	}

	private eventEmitter(mValue: string) {
		this.outOfRange = Utilities.isVoid(mValue);
		this.autoCompleteChangedEmitter.emit({
			value: mValue,
			out_of_range: this.outOfRange
		});
	}

	getMValue(label: string): string {
		if (!Utilities.isVoid(label) && label.length > 0) {
			const filtered = this.listFrom.filter(item =>
				(!Utilities.isVoid(item.labels) && !Utilities.isVoid(item.labels[this.locale])) ?
					item.labels[this.locale].toLowerCase() === label.toLowerCase() : item.value.toString().toLowerCase() === label.toLowerCase());
			return filtered.length === 1 ? filtered[0].value : null;
		}
		return '';
	}

	getMLabel(value: string): string {
		if (!Utilities.isVoid(value)) {
			const filtered = this.listFrom.filter(item => item.value.toString().toLowerCase() === value.toString().toLowerCase());
			return filtered.length === 1 && !Utilities.isVoid(filtered[0].labels) && !Utilities.isVoid(filtered[0].labels[this.locale]) ? filtered[0].labels[this.locale] : value;
		}
		return null;
	}

	displayFn(): string | undefined {
		return this.tempModel;
	}

	onBlur(event: any): void {
		setTimeout(() => {this.dirty = true}, 200);
		this.focusOut.emit();
	}

	onFocus(event: any): void {
		this.focusIn.emit();
	}
}

/**
 * auto-complete item structure
 *  {
 *  	value: string,
 *  	labels?: {
 *  		it: string,
 *  		en: string,
 *  		.
 *  		.
 *  		es: string
 *  	}
 *  }
 *
 *  note: labels is optional, if it missing we use value like label
 */

export interface AutoCompleteItemModel {
	value: any;
	labels?: AutoCompleteItemLabelsModel;
}

export interface AutoCompleteItemLabelsModel {
	it: string;
	en?: string;
	es?: string;
}

